import React from 'react';
import classnames from 'classnames';
import Icon from 'Components/Icon';
import { Tooltip } from 'Components/nui';
import { FormattedMessage } from 'react-intl';
import { ColumnTree } from '../hooks/useTable/defineColumns';

export const LegendTypeColumn = ColumnTree.defineNode(
  'legend-type',
  ({ productById }) => ({
    title: (
      <span>
        <FormattedMessage
          id="marketplace-table-subheading-ordertype"
          description="Table sub-heading, order type e.g. ([My] offer|bid)"
          defaultMessage="Type"
        />
      </span>
    ),
    key: 'type',
    className: 'col-product-type-alt',
    render: (text, record) => (
      <div className="td-content">
        <div className="col-product-type">
          <>
            <span
              className={classnames(`type-${record.type}`, {
                private: record.isprivate,
                counteronly: record.counteronly,
                disabled: !productById(record.product.id, record),
                'private-group':
                  (record.counterparties && record.counterparties.length > 1) ||
                  record.ismultiprivate,
              })}
            >
              {
                <FormattedMessage
                  id="marketplace-table-cell-ordertype"
                  description="Cell text for 'orderType' column in marketplace table"
                  defaultMessage="{is_owner, select, true {My } other {}}{counteronly, select, true {SFC } other {}} {type, select, bid {bid} offer {offer} other {{type}}}"
                  values={{
                    is_owner: record.is_owner,
                    counteronly: record.counteronly,
                    type: record.type,
                  }}
                />
              }
              {record.broker?.id && (
                <span className="broker">
                  <Tooltip
                    className="icon-help-circled"
                    placement="top"
                    title={
                      <span className="icon-tooltip">
                        <span className="icon-info-circled" />
                        <FormattedMessage
                          id="marketplace-table-cell-ordertype-broker-tooltip"
                          description="Broker Tooltip text for 'orderType' cell column in marketplace table"
                          defaultMessage="Broker order"
                        />
                      </span>
                    }
                  />
                </span>
              )}
              {record.isprivate && (
                <Tooltip
                  title={
                    <span className="icon-tooltip">
                      <span className="icon-info-circled" />
                      <FormattedMessage
                        id="marketplace-table-cell-ordertype-private-tooltip"
                        description="Private Tooltip text for 'orderType' cell column in marketplace table"
                        defaultMessage="{is_owner, select, true {My } other {}}Private {is_group, select, true {group } other {}}order"
                        values={{
                          is_owner: record.is_owner,
                          is_group:
                            (record.counterparties?.length ?? 0) > 1 ||
                            record.ismultiprivate,
                        }}
                      />
                    </span>
                  }
                >
                  <div>
                    <Icon
                      name={
                        record.isprivate &&
                        ((record.counterparties &&
                          record.counterparties.length > 1) ||
                          record.ismultiprivate)
                          ? 'lock'
                          : 'lock_person'
                      }
                      size="small"
                      className="private-icon tw:!bg-transparent tw:!text-gray-500 tw:!text-lg tw:relative tw:!top-[-5px]"
                    />
                  </div>
                </Tooltip>
              )}
            </span>
          </>
        </div>
      </div>
    ),
  })
);
